import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { authGuard } from './guards/auth.guard';
import { identityResolver } from './guards/resolver/identity.resolver';

const routes: Routes = [
  {
    canActivate: [authGuard],
    path: '',
    resolve: { data: identityResolver }, runGuardsAndResolvers: 'always', 
    loadChildren: () => import('./socialtravels-cms/socialtravels-cms.module').then((m) => m.SocialtravelsCmsModule),
  },
  {path: 'login', component: LoginComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
